module.exports = __webpack_public_path__ + "static/media/history.cf90682f.svg";